import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex: 1;

  & > button:last-child > div,
  & > button:last-child:hover:enabled > div {
    border-color: transparent;
  }
`;
